import { Typography } from "@mui/material";
import React from "react";
import ReactApexChart from '../../../../components/ReusableComponents/ApexChartLazy';

const RadialBarChart = ({ color, percentage, text }) => {
  const options = {
    series: [percentage],
    chart: {
      type: "radialBar",
      offsetY: -20,
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: "97%",
          margin: 5, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            color: "#999",
            opacity: 1,
            blur: 2,
          },
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            offsetY: -2,
            fontSize: "28px",
          },
        },
      },
    },
    grid: {
      padding: {
        top: -10,
      },
    },
    fill: {
      colors: [color], // Dark blue color
    },
    labels: ["Average Results"],
  };

  return (
    <div
      id="chart"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ReactApexChart
        options={options}
        series={options.series}
        type="radialBar"
        height={350}
      />
      <Typography>{text}</Typography>
    </div>
  );
};

export default RadialBarChart;
